import { render } from "./category-wizard.vue?vue&type=template&id=c36f8cd2&scoped=true&ts=true"
import script from "./category-wizard.vue?vue&type=script&lang=ts"
export * from "./category-wizard.vue?vue&type=script&lang=ts"

import "./category-wizard.vue?vue&type=style&index=0&id=c36f8cd2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36f8cd2"]])

export default __exports__